import {ButtonSecondary, gray50, IconPublic} from "@spotify-internal/encore-web";
import styled from "styled-components";
import {useT} from "@spotify-internal/i18n-core";
import {useLanguageSelectionDispatch} from "./LanguageSelection";

const PublicButton = styled(ButtonSecondary)`
  color: ${gray50};
  padding-inline-end: 0;
  border: none;
  &:hover {
    color: white;
  }
`;

export const LanguageSelectionButton = () => {
  const t = useT();
  const languageSelectionDispatch = useLanguageSelectionDispatch();

  return <PublicButton
      onClick={() => languageSelectionDispatch({type: 'open'})}
      iconLeading={IconPublic}
      aria-label={t(
          'AL_NAVIGATIONHEADER_0',
          'language picker',
          'aria label for icon to select language',
      )}
  />
}